module.exports = __webpack_public_path__ + "img/Flag_of_Belgium.477e53d6.svg";